var noUiSliderInit;

(function ($) {

	const selectors = {
		slider: '[data-range-input]',
		min_input: '[data-range-input-min]',
		max_input: '[data-range-input-max]',
	}

	noUiSliderInit = function () {
		$(selectors.slider).each((i, el) => {
			new NoUiSlider(el);
		})
	}

	class NoUiSlider {
		constructor(element) {
			this.$slider = $(element);

			if (this.$slider.length) {
				this.init();
			}

		}

		init() {

			const self = this;

			self.$wrap = this.$slider.parent();
			self.$min_input = $(selectors.min_input, self.$wrap);
			self.$max_input = $(selectors.max_input, self.$wrap);

			self.range = {
				'min': parseFloat(self.$slider.attr('min')),
				'max': parseFloat(self.$slider.attr('max'))
			};

			var current_values = [parseFloat(self.$min_input.val()) || self.range.min, parseFloat(self.$max_input.val()) || self.range.max];

			self.suffix = self.$slider.attr('data-suffix');

			self.nouislider = noUiSlider.create(self.$slider.get(0), {
				start: current_values,
				tooltips: [wNumb({ thousand: ' ', decimals: 0, suffix: self.suffix }), wNumb({ thousand: ' ', decimals: 0, suffix: self.suffix })],
				step: parseInt(self.$slider.attr('step')) || 1,
				connect: true,
				range: self.range
			});

			self.nouislider.on('update', function (values, handle) {
				self.$min_input.val(values[0]);
				self.$max_input.val(values[1]);

				const current_min = (parseFloat(values[0]) - self.range.min) / (self.range.max - self.range.min);
				const current_max = (parseFloat(values[1]) - self.range.min) / (self.range.max - self.range.min);

				if (current_min < 0.2 || values[0] == self.range.min) {
					self.$slider.addClass('at-start');
				}
				else {
					self.$slider.removeClass('at-start');
				}

				if (current_max > 0.8 || values[1] == self.range.max) {
					self.$slider.addClass('at-end');
				}
				else {
					self.$slider.removeClass('at-end');
				}

			});

		}
	}

})(jQuery);


export default noUiSliderInit;
